
import '../ContactPage/ContactPage.scss'


const BlogPage = ()=>{
return (
   <div className='contact-page'>
    <div className='contact-page__container'>
        <h2 className='contact-page__title'>Sorry, this page is in work now...</h2>
        
    </div>
    
   </div>
    
    
    
)
}

export default BlogPage;